import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Navbar from "../../Navbar";
import TablaPedidos from "./TablaPedidos";
import { logEventos } from "../../../services/services";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function PedidosTabs(props) {
  const esComercial= (localStorage.getItem("role")==="usuario" && parseInt(localStorage.getItem("sector"))===13);
  const [activeTab, setActiveTab] = useState(!esComercial ? 0 : 4);
  const [showTabs, setShowTabs] = useState(true);

  //Si es comercial de granel y rol usuario, infiero que es un comercial. por lo tanto solamente
  //le voy a habilitar los pedidos a facturar.
  useEffect(() => {
  logEventos(
  "acceso al menú Pedidos", 
  "Granel", 
  "tabs Pedidos", 
  localStorage.getItem("user"));

  console.log("es comercial", esComercial);
  console.log("sector",parseInt(localStorage.getItem("sector")));
  console.log("Es usuario",localStorage.getItem("role")==="usuario");
  
  
  
}, []);

  return (
    <div>
      <Navbar />
      {showTabs ? (
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 1 }}>
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            aria-label="basic tabs example"
            centered
            variant="fullWidth"
          >
            <Tab label="Todos" {...a11yProps(0)} disabled={esComercial}/>
            {/* <Tab label="Por Aprobar" {...a11yProps(1)} disabled={esComercial}/> */}
            <Tab label="Por Aprobar" {...a11yProps(1)} />
            <Tab label="Por Asignar" {...a11yProps(2)} disabled={esComercial}/>
            <Tab label="Asignados" {...a11yProps(3)} disabled={esComercial} />
            <Tab label="A Facturar" {...a11yProps(4)} />
            {/* <Tab label="No Entregados" {...a11yProps(5)} disabled={esComercial}/> */}
            <Tab label="Facturados" {...a11yProps(6)} disabled={esComercial}/>
          </Tabs>
        </Box>
      ) : null}
      <TablaPedidos activeTab={activeTab} setShowTabs={setShowTabs} esComercial={esComercial}/>
    </div>
  );
}

export default PedidosTabs;

// 21-8 :modificacion -> habilite el tab "Por Aprobar" para que también lo puedan visualizar los comerciales.
